import React from 'react';

const Clients = ({}) => (
  <div className="section is-medium no-line-bottom wavy-bottom">
      <div className="container">
          <div className="content-wrapper huge-pb">
              <div className="grid-clients four-grid">
                  <div className="columns is-vcentered">
                  <div className="column"></div>
                      <div className="column">
                          <a><img className="client" src="assets/images/logos/customer/atay-logo.png" alt="" /></a>
                      </div>
                      <div className="column">
                          <a><img className="client" src="assets/images/logos/customer/baran-logo.png" alt="" /></a>
                      </div>
                      <div className="column">
                          <a><img className="client" src="assets/images/logos/customer/bki-logo.png" alt="" /></a>
                      </div>
                      <div className="column">
                          <a><img className="client" src="assets/images/logos/customer/aydin-linyit-logo.png" alt="" /></a>
                      </div>
                      <div className="column"></div>
                  </div>
                  <div className="columns is-vcentered is-separator">
                  <div className="column"></div>
                      <div className="column">
                          <a><img className="client" src="assets/images/logos/customer/papirus-logo.png" alt="" /></a>
                      </div>
                      <div className="column">
                          <a><img className="client" src="assets/images/logos/customer/ototay-logo.png" alt="" /></a>
                      </div>
                      <div className="column">
                          <a><img className="client" src="assets/images/logos/customer/dedeman-logo.png" alt="" /></a>
                      </div>
                      <div className="column">
                          <a><img className="client" src="assets/images/logos/customer/gidatay-logo.png" alt="" /></a>
                      </div>
                      <div className="column"></div>
                  </div>
              </div>
          </div>
      </div>
  </div>
);

export default Clients;
